import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ArticlesService } from '../../../services/articles.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
@Component({
  selector: 'app-articles-create',
  templateUrl: './articles-create.component.html',
  styleUrls: ['./articles-create.component.scss']
})
export class ArticlesCreateComponent implements OnInit {
    pagecode: string = "article-submit";
    module: string = "articles";
    accessdenied: boolean = false;
    btnVerifyDisabled: boolean = false;
    btnVerifyText: string = "Submit";
    article: any = {
        article: "",
        title: "",
        authorName: this.authentication.userData.firstName + " " + this.authentication.userData.lastName,
        createdUserId: this.authentication._authentication.id,
        status: "submitted",
        source: "mygistec",
        navigateType: "internal",
        navigateUrl: ""
    }
    imageChangedEventCover: any = '';
    croppedImageCover: any = '';

    modulecode: string = "articles";
    Menu: any[];
    pagetitle: string;

    constructor(private route: ActivatedRoute,
        private router: Router, private articlesService: ArticlesService,
        private authentication: AuthenticationService,
        private common: CommonService) { }

    ngOnInit(): void {
        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);
                        this.getSubMenuItems();
                        window.scroll(0, 0);

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });
  }
    fileChangeEventCover(event: any): void {
        this.imageChangedEventCover = event;
    }
    imageCroppedCover(event: any) {
        this.croppedImageCover = event.base64;
    }
    imageLoadedCover() {
        // show cropper
    }
    loadImageFailedCover() {
        //this.ShowMessage('error', 'Error in loading profile picture. Choose another one', '');
    }
    public getSubMenuItems() {
        debugger;
        let userMenus = this.common.userMenus;
        this.Menu = [];
        for (var i = 0; i < userMenus.length; i++) {
            if (userMenus[i].menuModule.moduleCode.toLowerCase() == this.modulecode.toLowerCase()) {
                if (userMenus[i].menuCode.toLowerCase() == this.pagecode.toLowerCase()) {
                    this.pagetitle = userMenus[i].menuName;
                    //userMenus[i].isActiveMenu = true;
                }
                else {
                    userMenus[i].isActiveMenu = false;
                    this.Menu.push(userMenus[i]);
                }
            }
        }
    }
    submitArticle() {
        if (this.formValidation()) {
            this.article.coverImage = this.croppedImageCover;
            //console.log("article", this.article);
            this.articlesService.createArticle(this.article).subscribe(
                (res: any) => {
                    if (res.success) {
                        this.common.ShowMessage("info", "The article was successfully submitted and pending for team review", "");
                        this.router.navigate(["/articles/all"]);
                    }
                },
                (err: any) => {
                    console.error("Web/Articles/submitArticle()", err);
                }
            );
        }
    }
    selectArticleTypeOption(evt: any) {
        //console.log("value", evt.target.value);
        this.article.navigateType = evt.target.value;
        if (this.article.navigateType == 'internal')
            this.article.source = 'mygistec';
        else
            this.article.source = "";
    }
    formValidation(): boolean {
        if (this.article.title === '') {
            this.common.ShowMessage("error", "Article title is mandatory", "");
            return false;
        }
        else if (this.article.authorName === '') {
            this.common.ShowMessage("error", "Author name is mandatory", "");
            return false;
        }
        else if (this.article.source === '') {
            this.common.ShowMessage("error", "Article source is mandatory", "");
            return false;
        }
        else if (this.article.navigateUrl === '' && this.article.navigateType === 'external') {
            this.common.ShowMessage("error", "Article URL is mandatory", "");
            return false;
        }
        else if (this.article.navigateUrl != '' && this.article.navigateType === 'external') {
            if (!this.common.ValidateURL(this.article.navigateUrl)) {
                this.common.ShowMessage("error", "Article URL is invalid", "");
                return false;
            }
        }
        else if (this.article.article === '' && this.article.navigateType === 'internal') {
            this.common.ShowMessage("error", "Article is mandatory", "");
            return false;
        }
        else if (this.croppedImageCover == '') {
            this.common.ShowMessage("error", "Article cover image is mandatory", "");
            return false;
        }
        return true;
    }
}
